<template>
  <div class="about container">
    <h1>关于实验室</h1>
    <hr />计算机学院软件孵化实验室，成立于2014年5月，致力于为学生提供综合素养的成长环境、为学生提供跨学科领域的实训平台、为学生提供技术方向引导的师资力量。
    <h3>一、面向对象</h3>计算机学院大一至大三计科及软件专业的同学。
    <h3>二、基本要求</h3>
    <p>1. 具备对软件开发领域知识的求知欲；</p>
    <p>2. 具备基本的交流与组织能力；</p>
    <p>3. 愿意投入时间与精力学习软件开发技术；</p>
    <p>4. 愿意遵守实验室各项规章制度。</p>
    <h3>三、基本制度</h3>
    <p>1. 实验室只用于与软件开发相应事务及经实验室主管许可的相关活动，除此未经许可不得在实验内从事无关软件开发主旨的事情；</p>
    <p>2. 进驻实验室人员需要遵从学校与学院各项管理规章制度，需要保证基础学业全面发展的前提下，再进行软件开发能力的提升；</p>
    <p>3. 进驻实验室人员在培训期间，需要按时并高质量完成指导老师所分派的各项开发任务；</p>
    <p>4. 进驻实验室人员需要保证实验室安全；</p>
    <p>5. 在日常学习过程中，禁止进行任何可能影响他人的行为；</p>
    <p>6. 保持实验室整洁，轮值完成公共环境的清洁工作；</p>
    <p>7. 对于违反以上规定的进驻实验室人员，由实验室主管批准，可以取消相关人员的进驻资格。</p>
    <h3>四、培训形式</h3>
    <p>1. 采用“任务驱动”的方式完成项目实战。目前已完成项目包括“计算山理”微信公众号的查询子系统等。</p>
    <p>2. 导师跟踪指导完成创新竞赛项目的开发。目前已指导数十名学员参加各类软件开发类竞赛，并在齐鲁大学生软件大赛中，获得了一个一等奖、六个二等奖和二个三等奖的优异成绩。</p>
    <p>3. 举办专题讲座拓展专业视野。目前已邀请学院新进博士、优秀学长举办关于“医学图像处理”、“海洋图像数据处理”和“Web前端技术”等多项专题讲座。</p>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about {
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue